import { type Editor } from '@tiptap/react';

import { isEditorLive } from '@heidi/editor/core';
export interface SelectionSourceRange {
  from: number;
  to: number;
}

/** Canonical serialization for inline selection edit staleness checks and prompts. */
export const getRangeSourceText = (
  editor: Editor,
  range: SelectionSourceRange
): string | null => {
  if (!isEditorLive(editor, 'selection-source-text') || range.from >= range.to)
    return null;
  try {
    return editor.state.doc.textBetween(range.from, range.to, '\n');
  } catch {
    return null;
  }
};

export const selectionSourceMatches = (
  editor: Editor,
  range: SelectionSourceRange,
  sourceText: string
): boolean => getRangeSourceText(editor, range) === sourceText;
